import {useCallback} from 'react';

export const useSendNotification = (authorizedHttpClient) => {
    const sendNotification = useCallback(
        async (targetUserId, title, messageBody) => {
            try {
                // Pass targetUserId along with the title and body in the payload
                const payload = {targetUserId, title, body: messageBody};
                console.log("Payload for sending notification:", payload);
                const response = await authorizedHttpClient.jsonRequest(
                    'POST',
                    '/notifications/send-notification',
                    undefined, // ✅ queryParams
                    payload
                );
                return response;
            } catch (error) {
                console.error('Error sending notification:', error);
                return null;
            }
        },
        [authorizedHttpClient]
    );

    return sendNotification;
};
